const $ = require('jquery');
// TODO: include jquery.gmap3/google maps script only where needed
// maybe add this file only on happenings page
const gmap3 = require('gmap3');

module.exports = {
  // attending status pasākumam
  changeAttendingStatus() {
    const _this = this;
    $(document).on('pjax:beforeReplace', () => {
      $(document).off('change', '.attending_status select');
    });
    $(document).on('change', '.attending_status select', function () {
      // document.querySelectorAll('.happening_submit').click();
      $(this).closest('.form-attending').find('.happening_submit').click();
      //
      const $happeningBlock = $(this).closest('.happeningBlock');
      if ($happeningBlock.length && $happeningBlock.hasClass('discussionBlock--unread')) {
        $happeningBlock.removeClass('discussionBlock--unread');
      }
    });
  },
  addHappeningMap() {
    // $(document).ready(function() {
    // Load google map
    const $mapItem = document.getElementById('gmap');
    if ($mapItem == null) {
      return false;
    }

    let $mapCenter = new google.maps.LatLng(56.944678, 24.100372);

    if ($mapItem.getAttribute('data-coords-lat') != false && $mapItem.getAttribute('data-coords-long') != false) {
      $mapCenter = new google.maps.LatLng($mapItem.getAttribute('data-coords-lat'), $mapItem.getAttribute('data-coords-long'));
    }

    const map = new google.maps.Map($mapItem, {
      center: $mapCenter,
      zoom: 8,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: false,
      streetViewControl: false,
      mapTypeControl: false,
    });

    let markers = [];

    if ($mapItem.getAttribute('data-coords-lat') != false && $mapItem.getAttribute('data-coords-long') != false) {
      const coords = new google.maps.LatLng($mapItem.getAttribute('data-coords-lat'), $mapItem.getAttribute('data-coords-long'));
      addMarker(coords);
      map.setZoom(13);
    }

    map.addListener('click', (event) => {
      addMarker(event.latLng);
    });

    function clearMarkers() {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
      markers = [];
    }

    function addMarker(coords) {
      // Clear all markers before adding new one
      clearMarkers();

      // Set marker also
      if (typeof marker !== 'undefined') {
        marker.setMap(null);
      }
      var marker = new google.maps.Marker({
        position: coords,
        map,
        title: jQuery('input[name=location]').val(),
      });
      markers.push(marker);

      $('#CoordsLat').val(coords.lat());
      $('#CoordsLong').val(coords.lng());

      map.setCenter(coords);
      // map.setZoom(15);
    }

    function searchCoordsByAdress() {
      const geocoder = new google.maps.Geocoder();
      let location = $('#Location').val();
      if (typeof location === 'undefined') {
        location = $('#HappeningsLocation').val();
      }

      geocoder.geocode(
        {
          address: location,
          region: 'no',
        },
        (results, status) => {
          if (status.toLowerCase() == 'ok') {
          // Get center
            const coords = new google.maps.LatLng(
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng(),
            );

            addMarker(coords);
          }
        },
      );
    }

    jQuery('button[name=search]').click(() => {
      searchCoordsByAdress();
    });

    $(document).keyup((e) => {
      if ($('#Location').is(':focus') && (e.keyCode === 13)) {
        searchCoordsByAdress();
      }
    });

    jQuery('#CoordsLat, #CoordsLong').change(() => {
      const coords = new google.maps.LatLng(
        $('#CoordsLat').val(),
        $('#CoordsLong').val(),
      );

      map.setCenter(coords);
      // map.setZoom(15);

      addMarker(coords);
    });

    // });
  },
  showHappeningMap() {
    const $objectMap = $('.object_map_map');
    if (!$objectMap.length) {
      return false;
    }

    const $options = {
      zoom: 15,
      mapTypeControl: false,
      navigationControl: true,
      scrollwheel: true,
      streetViewControl: false,
    };

    if ($objectMap.data('coords-lat') != false && $objectMap.data('coords-long') != false) {
      $options.center = [$objectMap.data('coords-lat'), $objectMap.data('coords-long')];
      const $marker = { latLng: [$objectMap.data('coords-lat'), $objectMap.data('coords-long')] };

      $objectMap.gmap3({
        map: {
          options: $options,
        },
        marker: $marker,
      });
    } else {
      $options.address = $objectMap.data('adress');
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: $objectMap.data('adress'),
          region: 'no',
        },
        (results, status) => {
          if (status.toLowerCase() == 'ok') {
          // Get center
            $options.center = [results[0].geometry.location.lat(), results[0].geometry.location.lng()];
            const $marker = { latLng: [results[0].geometry.location.lat(), results[0].geometry.location.lng()] };

            $objectMap.gmap3({
              map: {
                options: $options,
              },
              marker: $marker,
            });
          } else {
            $objectMap.remove();
          }
        },
      );
    }
  },
  handleImagePreview() {
    $('form#happeningPost-submit input[type="file"]').on('change', function () {
      if (typeof (FileReader) !== 'undefined') {
        const image_holder = $(this).closest('form').find('.happenings-imagePreview');
        image_holder.empty();

        const reader = new FileReader();
        reader.onload = function (e) {
          $('<img />', {
            src: e.target.result,
            class: 'thumb-image',
          }).appendTo(image_holder);
        };
        image_holder.show();
        reader.readAsDataURL($(this)[0].files[0]);
      }
    });
  },
  validateHappeningsForm() {
    $('form#happeningPost-submit').bind('keypress', function (e) {
      if (e.keyCode == 13 && $(this).find('#Location').is(':focus')) {
        return false;
      }
    });

    $('form#happeningPost-submit').on('submit', function (e) {
      $('.form-group').removeClass('error');

      let error = false,
        title = $(this).find('input[name="title"]'),
        text = $(this).find('textarea[name="text"]'),
        start_date_day = $(this).find('select[name="start_date[day]"]'),
        start_date_month = $(this).find('select[name="start_date[month]"]'),
        start_date_year = $(this).find('select[name="start_date[year]"]'),
        start_date_hours = $(this).find('select[name="start_date[hours]"]'),
        start_date_minutes = $(this).find('select[name="start_date[minutes]"]'),
        end_date_day = $(this).find('select[name="end_date[day]"]'),
        end_date_month = $(this).find('select[name="end_date[month]"]'),
        end_date_year = $(this).find('select[name="end_date[year]"]'),
        end_date_hours = $(this).find('select[name="end_date[hours]"]'),
        end_date_minutes = $(this).find('select[name="end_date[minutes]"]'),
        location = $(this).find('input[name="location"]'),
        not_empty = [title, text, start_date_day, start_date_month, start_date_year, start_date_hours, start_date_minutes, location];

      // vai lauki nav tukši
      $.each(not_empty, (index, field) => {
        if (field.val().length < 1) {
          field.closest('.form-group').addClass('error');
          error = true;
        }
      });

      // vai beigu datums nav mazāks par sākuma
      if (
        start_date_day.val().length > 0 &&
				start_date_month.val().length > 0 &&
				start_date_year.val().length > 0 &&
				end_date_day.val().length > 0 &&
				end_date_month.val().length > 0 &&
				end_date_year.val().length > 0
      ) {
        var start_date = new Date(start_date_year.val(), start_date_month.val() - 1, start_date_day.val());
        var end_date = new Date(end_date_year.val(), end_date_month.val() - 1, end_date_day.val());
        if (end_date < start_date) {
          end_date_day.closest('.form-group').addClass('error');
          error = true;
        }

        // ja vienādi datumi, tad pārbaudam vai laiku
        if (
          start_date_hours.val().length > 0 &&
					start_date_minutes.val().length > 0 &&
					end_date_hours.val().length > 0 &&
					end_date_minutes.val().length > 0 &&
					start_date.getTime() === end_date.getTime()
        ) {
          var start_date = new Date(start_date_year.val(), start_date_month.val() - 1, start_date_day.val(), start_date_hours.val(), start_date_minutes.val());
          var end_date = new Date(end_date_year.val(), end_date_month.val() - 1, end_date_day.val(), end_date_hours.val(), end_date_minutes.val());
          if (end_date < start_date) {
            end_date_hours.closest('.form-group').addClass('error');
            error = true;
          }
        }
      }

      if (error) {
        // For some reason, when not using dev server, this fails and form gets submitted anyway.
        // But.. putting random 'console.log' here fixes it.
        // Seems so strange.. What could be the reason for something like that.
        console.log('error');
        return false;
      }
    });
  },
  init() {
    const _this = this;
    this.changeAttendingStatus();
    this.addHappeningMap();
    this.showHappeningMap();
    this.handleImagePreview();
    this.validateHappeningsForm();
  },
};
